module.exports = __webpack_public_path__ + "static/media/Architecture_23.349917ad.jpg";